import {
  IconRankingArrowLeft,
  IconRankingArrowRight,
  IconRankingMoreHoriz,
} from "assets/svg";
import React from "react";

interface RankingPaginationProps {
  page: number;
  totalPages: number;
  visible: boolean;
  onPageChange: (page: number) => void;
}

const RankingPagination = ({
  page,
  totalPages,
  visible,
  onPageChange,
}: RankingPaginationProps) => {
  const paginationItems: Array<number | "ellipsis"> =
    totalPages > 5
      ? [1, 2, 3, "ellipsis", totalPages]
      : Array.from({ length: totalPages }, (_, index) => index + 1);

  return (
    <div
      className={`min-h-[60px] items-center justify-center gap-[5px] bg-white px-[20px] py-[15px] ${
        visible ? "flex" : "hidden"
      }`}
    >
      <button
        type="button"
        aria-label="前のページ"
        disabled={page === 1}
        onClick={() => onPageChange(Math.max(1, page - 1))}
        className="inline-flex h-[30px] w-[30px] items-center justify-center text-primary disabled:opacity-30"
      >
        <IconRankingArrowLeft
          data-testid="pagination-prev-icon"
          className="h-[12px] w-[7px]"
        />
      </button>
      {paginationItems.map((item) =>
        item === "ellipsis" ? (
          <span
            key={item}
            className="inline-flex h-[30px] w-[30px] items-center justify-center"
          >
            <IconRankingMoreHoriz className="h-[4px] w-[16px]" />
          </span>
        ) : (
          <button
            key={item}
            type="button"
            aria-label={`ページ ${item}`}
            onClick={() => onPageChange(item)}
            className={`h-[30px] min-w-[30px] rounded-full px-[8px] text-[14px] font-bold ${
              page === item ? "bg-primary text-white" : "bg-white text-primary"
            }`}
          >
            {item}
          </button>
        ),
      )}
      <button
        type="button"
        aria-label="次のページ"
        disabled={page === totalPages}
        onClick={() => onPageChange(Math.min(totalPages, page + 1))}
        className="inline-flex h-[30px] w-[30px] items-center justify-center text-primary disabled:opacity-30"
      >
        <IconRankingArrowRight
          data-testid="pagination-next-icon"
          className="h-[12px] w-[7px]"
        />
      </button>
    </div>
  );
};

export default RankingPagination;
